module.exports = __webpack_public_path__ + "593a3d53/img/upload-icon.9179ae4e.svg";